import { useNavigate } from "react-router-dom";
import { T } from "../constants/theme";

export default function Footer() {
  const navigate = useNavigate();
  const setPage = (r) => navigate(`/${r}`);
  const footerLink = {
    background: "none",
    border: "none",
    color: T.faint,
    padding: 0,
    cursor: "pointer",
    fontSize: 14,
    textAlign: "left",
  };

  return (
    <footer
      style={{
        background: "#0f0f0f",
        color: "#d6d6d6",
        marginTop: 0,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "70px 24px 50px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "minmax(250px,2fr) repeat(auto-fit,minmax(160px,1fr))",
            gap: 40,
          }}
        >
          {/* Brand */}
          <div>
            <h2
              style={{
                color: "#fff",
                margin: 0,
                fontFamily: "'Georgia', serif",
                fontSize: 28,
              }}
            >
              Greenbless
            </h2>

            <p
              style={{
                color: "#999",
                marginTop: 18,
                lineHeight: 1.8,
                maxWidth: 320,
              }}
            >
              Trusted supplies for growers of every kind.
              Discover fresh produce, quality seeds and plants,
              and the tools and fertilisers that keep your garden
              and farm thriving.
            </p>

           {/* <div
  style={{
    display: "flex",
    gap: 12,
    marginTop: 24,
  }}
>
  {[
    <FaFacebookF />,
    <FaInstagram />,
    <FaXTwitter />,
    <FaYoutube />,
  ].map((icon, i) => (
    <div
      key={i}
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#fff",
        fontSize: 18,
        transition: "all .25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = T.gold;
        e.currentTarget.style.borderColor = T.gold;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.borderColor =
          "rgba(255,255,255,.15)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {icon}
    </div>
  ))}
</div> */}
          </div>

          {/* Shop */}
          <div>
            <h4
              style={{
                color: "#fff",
                marginBottom: 18,
              }}
            >
              Shop
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button
                onClick={() => setPage("shop")}
                style={footerLink}
              >
                New Arrivals
              </button>

              <button
                onClick={() => setPage("shop?cat=Fresh Produce")}
                style={footerLink}
              >
                Fresh Produce
              </button>

              <button
                onClick={() => setPage("shop?cat=Seeds & Plants")}
                style={footerLink}
              >
                Seeds & Plants
              </button>

              <button
                onClick={() => setPage("shop?cat=Garden Tools")}
                style={footerLink}
              >
                Garden Tools
              </button>

              <button
                onClick={() => setPage("shop?cat=Compost & Soil")}
                style={footerLink}
              >
                Compost & Soil
              </button>
            </div>
          </div>

          {/* Customer Care */}
          <div>
            <h4
              style={{
                color: "#fff",
                marginBottom: 18,
              }}
            >
              Customer Care
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button style={footerLink}>
                Contact Us
              </button>

              <button style={footerLink}>
                Shipping Information
              </button>

              <button style={footerLink}>
                Returns & Exchanges
              </button>

              <button style={footerLink}>
                FAQ
              </button>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4
              style={{
                color: "#fff",
                marginBottom: 18,
              }}
            >
              Company
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button style={footerLink}>
                About Us
              </button>

              <button style={footerLink}>
                Sustainability
              </button>

              <button style={footerLink}>
                Careers
              </button>

              <button style={footerLink}>
                Blog
              </button>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4
              style={{
                color: "#fff",
                marginBottom: 18,
              }}
            >
              Stay Updated
            </h4>

            <p
              style={{
                color: "#999",
                fontSize: 14,
                lineHeight: 1.7,
              }}
            >
              Subscribe for exclusive offers,
              new arrivals and growing tips.
            </p>

            <div
              style={{
                display: "flex",
                marginTop: 16,
              }}
            >
              <input
                placeholder="Email address"
                style={{
                  flex: 1,
                  padding: "12px 14px",
                  border: "1px solid #333",
                  background: "#161616",
                  color: "#fff",
                  outline: "none",
                }}
              />

              <button
                style={{
                  background: T.gold,
                  color: "#fff",
                  border: "none",
                  padding: "0 18px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,.08)",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "24px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 20,
            color: "#8a8a8a",
            fontSize: 13,
          }}
        >
          <div>
            © 2026 Greenbless. All rights reserved.
          </div>

          <div
            style={{
              display: "flex",
              gap: 20,
            }}
          >
            <span>Privacy Policy</span>
            <span>Terms & Conditions</span>
            <span>Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
